import React from 'react'
import { CheckboxGroup, Checkmark } from '@chakra-ui/react'
import { Checkbox } from '@/components/ui/checkbox'

export default ({ id, value, size, disabled, checked, isChecked, onChange, onCheckedChange, children }) => {
  return (
    <Checkbox
      id={id}
      size={size}
      disabled={disabled}
      checked={checked ?? isChecked}
      onCheckedChange={onChange || onCheckedChange}
      value={value}
    >
      {children}
    </Checkbox>
  )
}

export { CheckboxGroup, Checkmark }
